import { SxProps, Theme } from '@mui/material';

export const productCardImagerSX: SxProps<Theme> = () => ({
	height: {
		xs: '200px',
		sm: '200px',
	},
	width: {
		xs: '200px',
		sm: '200px',
	},
});
